import { render, staticRenderFns } from "./TransactionEditor.vue?vue&type=template&id=25ed6cc6&scoped=true&"
import script from "./TransactionEditor.vue?vue&type=script&lang=js&"
export * from "./TransactionEditor.vue?vue&type=script&lang=js&"
import style0 from "./TransactionEditor.vue?vue&type=style&index=0&id=25ed6cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed6cc6",
  null
  
)

export default component.exports